import { WtLoginKey } from "../constants/loginKeys"
import { Env } from '../controller/constant'

export const getLoggedUserInfo = (req) => {
    let uInfo = JSON.parse(localStorage.getItem('uInfo'))
    let info = ''

    if (req === WtLoginKey.userInfo) info = uInfo || false
    if (req === WtLoginKey.userId) info = uInfo?.emp?._id || false
    if (req === WtLoginKey.userName) info = uInfo?.emp?.name || false
    if (req === WtLoginKey.userEmail) info = uInfo?.emp?.email || false
    if (req === WtLoginKey.userEmailVerified) info = uInfo?.emp?.emailVerified || false
    if (req === WtLoginKey.userWhatsApp) info = uInfo?.emp?.whatsapp || false
    if (req === WtLoginKey.userWhatsAppVerified) info = uInfo?.emp?.whatsappVerified || false
    if (req === WtLoginKey.userRole) info = uInfo?.emp?.role || false

    if (req === WtLoginKey.businessId) info = uInfo?.business?._id || false
    if (req === WtLoginKey.businessName) info = uInfo?.business?.name || false
    if (req === WtLoginKey.businessEmail) info = uInfo?.business?.supportEmail || false
    if (req === WtLoginKey.businessWebsite) info = uInfo?.business?.website || false
    if (req === WtLoginKey.businessOnBoardingStatus) info = uInfo?.business?.onboardingStatus || 'undefined'

    if (req === WtLoginKey.channelObj) info = JSON.stringify(uInfo?.channels) || false

    if (req === WtLoginKey.authToken) info = uInfo?.authToken || false

    return info
}

export const showConsole = (info) => {
    if (Env.env_type !== 'production') { return console.log(info) } else { return }
}